import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../_services/authenication.service';
import { EventsService } from "../../_services/events.service";
import { ContactusService } from '../../_services/contactus.service'
import { ToasterService } from '../../_services/toaster.service';
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {ExcelServicesService} from "../../_services/excel-services.service";

import {environment} from '../../../environments/environment';

declare var $: any;

@Component({
  selector: 'app-get-recommendation-values',
  templateUrl: './get-recommendation-values.component.html',
  styleUrls: ['./get-recommendation-values.component.css']
})
export class GetRecommendationValuesComponent implements OnInit {

  List: any[] = [];
  Lists: any[] = [];
  userdetaild: string;
  returnUrl: string;
  baseUrl: string = environment.baseUrl;
  imgKey: string = environment.imgKey;
  encodedKey: string;
  page = 1;
  size = 10;
  count = 0;
  total: any;
  searchValue = '';

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute,private toaster: ToasterService, private contactusService: ContactusService, private excelService:ExcelServicesService,private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.encodedKey = btoa(this.imgKey);
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/internal-admin']);
    }

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getRecommendationReview(this.page, this.size);

    setTimeout(()=>{
      this.getRecommendationExcel(this.page, (this.count == 0)?this.List.length:this.count);
    },2000)
  }
  getRecommendationReview(page, size) {
    this.contactusService.getRecommendationReview(page, size)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.count = (data.Data.total)?data.Data.total:0;
            this.List = data.Data.ratings;
            

            // setTimeout(()=>{
            //   $(function() {
            //     $('#example').DataTable();
            //   });
            // }, 1000);

          } else {
            this.toaster.showError('eventsList', data.ResponseMessage);
            // setTimeout( () => {
            //   $(function () {
            //     $('#example').DataTable();
            //   });
            // }, 1000);
          }
        },
        error => {
          this.toaster.showError('eventsList', error.error.ResponseMessage);
          // setTimeout( () => {
          //   $(function () {
          //     $('#example').DataTable();
          //   });
          // }, 1000);
        });
  }

  getRecommendationExcel(page, size) {
    this.contactusService.getRecommendationReview(page, size)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.Lists = data.Data.ratings;
          } 
        },
        error => {
          // this.toaster.showError('eventsList', error.error.ResponseMessage);
        });
  }

  exportAsXLSX():void {
    this.spinnerService.show();
    this.excelService.exportAsExcelFile(this.Lists, 'recommendation_list');
    this.spinnerService.hide();
  }

  createRange(number) {
    this.total = [];
    const num = (number / this.size);
    for (let i = 1; i <= Math.ceil(num); i++) {
      this.total.push(i);
    }
    return this.total;
  
  }
  
  pageChanged(event){
    this.page = event;
    // const payload = {
    //   value: this.searchValue,
     
    // };
  
    this.getRecommendationReview(this.page, this.size);
  }
  
  Sort(event){
      
    this.size = event.target.value;
    // const payload = {
    //   value: this.searchValue,
      
    // };
  
    this.getRecommendationReview(this.page, this.size);
  }
  
  search(event){
      
      // let strLeng = event.target.value.length;
  
      this.searchValue = event.target.value;
        // const payload = {
        //   value: event.target.value,
          
        // };
  
        this.getRecommendationReview(this.page, this.size);
  }

}
